/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainEntitiesDocumentsDocumentAccountAccept interface.
 */
export function instanceOfFxIdDomainEntitiesDocumentsDocumentAccountAccept(value) {
    if (!('Id' in value) || value['Id'] === undefined)
        return false;
    if (!('AccountId' in value) || value['AccountId'] === undefined)
        return false;
    if (!('AcceptedAt' in value) || value['AcceptedAt'] === undefined)
        return false;
    if (!('DocumentVersionId' in value) || value['DocumentVersionId'] === undefined)
        return false;
    return true;
}
export function FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Id': json['Id'],
        'AccountId': json['AccountId'],
        'AcceptedAt': (new Date(json['AcceptedAt'])),
        'DocumentVersionId': json['DocumentVersionId'],
    };
}
export function FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['Id'],
        'AccountId': value['AccountId'],
        'AcceptedAt': ((value['AcceptedAt']).toISOString()),
        'DocumentVersionId': value['DocumentVersionId'],
    };
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsDocumentAccountAccept.js.map